import React, { Component } from 'react';
import { Line, Bar, Radar } from 'react-chartjs-2';
import { Grid, Header, Icon, Segment, Table, Dropdown, Container, Radio, Button } from 'semantic-ui-react';
import moment from 'moment';
import _ from 'lodash';
import TypeList from '../filter4.json';
import { connect } from 'react-redux';
import Page from '../../components/Page';
import { withTranslation } from 'react-i18next';
import 'moment/locale/tr';
import { colors2 } from '../../constants/colors';
import MockAgents from './mock.json';

const ChartWrap = (props) => (
	<Grid.Column width={props.width}>
		<Header as="h4" attached="top" style={{ display: 'flex' }}>
			<Icon name={props.icon || 'chart bar'} />
			<Header.Content>{props.title}</Header.Content>
			{props.content}
		</Header>
		<Segment attached>{props.children}</Segment>
	</Grid.Column>
);

const barOptions = {
	scales: {
		xAxes: [{ stacked: false }],
		yAxes: [{ stacked: false, ticks: { min: 0 } }],
	},
	tooltips: {
		mode: 'index',
		intersect: false,
		filter: (a) => a.yLabel,
	},
	hover: {
		mode: 'nearest',
		intersect: true,
	},
	legend: {
		display: true,
		labels: { fill: false },
	},
};
const barOptionsStack = {
	scales: {
		xAxes: [{ stacked: true }],
		yAxes: [{ stacked: true, ticks: { min: 0 } }],
	},
	tooltips: {
		mode: 'index',
		intersect: true,
		filter: (a) => a.yLabel,
	},
	hover: {
		mode: 'nearest',
		intersect: true,
	},
	legend: {
		display: true,
		labels: { fill: false },
	},
};

class Analytic extends Component {
	state = {
		filterType: false,
		filterAgent: false,
		loading: true,
		start_date: this.props.start_date,
		end_date: this.props.end_date,
		today: moment(),
		group: ['agent'],
		value: _.map(TypeList, (it) => {
			return it;
		}),
		agent_role: this.props.access.user.loggedUserObj.role,
		agent_id: this.props.access.user.loggedUserObj.extra.user_id,
		pid: /* '02cc63330cd0808f87c54ad9dd94b74a' ||  */ this.props.product.live.settings.live.token,
		selectedAgent: 'all',
		selectedDate: 'daily',
		groupBy: 'agent',
		selectedTopic: 'all',
		column: null,
		botId: '',
		direction: null,
		dataloading: true,
		displayName: 'developer',
		selectedBarStyle: 'line',
		loadingGraph: true,
		selectedPlatform: 'all',
		selectedWatsonsGroup: 'all',
		selectedTeam: 'all',
	};
	handleSort = (clickedColumn) => () => {
		const { column, direction } = this.state;
		if (column !== clickedColumn) {
			this.setState({
				column: clickedColumn,
				direction: 'desc',
			});

			return;
		}
		this.setState({
			direction: direction === 'asc' ? 'desc' : 'asc',
		});
	};
	TableHead = (data, keys, head, column, direction, tcloumn, ratePoint, t) => (
		<Table.Header>
			<Table.Row>
				<Table.HeaderCell>{t('conversation')}</Table.HeaderCell>
				<Table.HeaderCell sorted={column === tcloumn ? direction : null} onClick={this.handleSort('count')}>
					{t('count')}
				</Table.HeaderCell>
			</Table.Row>
		</Table.Header>
	);
	TableLine = (
		data,
		productAgentList,
		closeTags,
		group,
		productAgentList2,
		column,
		direction,
		ratePoint,
		selectedAgent,
		sumFilterData,
		t,
		selectedTopic,
		unique_total_closed,
		total_closed,
		repetitive_conversation,
		agent_closed,
		unique_agent_closed
	) => (
		<Table.Body>
			<Table.Row key={'all1'}>
				<Table.Cell>Toplam Kapatma Sayısı (auto_close dahil)</Table.Cell>
				<Table.Cell>{total_closed}</Table.Cell>
			</Table.Row>
			<Table.Row key={'all2'}>
				<Table.Cell>Tekil Toplam Kapatma Sayısı (auto_close dahil)</Table.Cell>
				<Table.Cell>{unique_total_closed.length}</Table.Cell>
			</Table.Row>
			<Table.Row key={'all3'}>
				<Table.Cell>Agent Toplam Kapatma Sayısı (auto_close hariç)</Table.Cell>
				<Table.Cell>{agent_closed.length}</Table.Cell>
			</Table.Row>
			<Table.Row key={'all4'}>
				<Table.Cell>Agent Tekil Toplam Kapatma Sayısı (auto_close hariç)</Table.Cell>
				<Table.Cell>{unique_agent_closed.length}</Table.Cell>
			</Table.Row>
			<Table.Row key={'all5'}>
				<Table.Cell>Mükerrer Kapatılan Konuşma Sayısı</Table.Cell>
				<Table.Cell>{repetitive_conversation.length}</Table.Cell>
			</Table.Row>
			<Table.Row key={'all6'}>
				<Table.Cell>5 ve Daha Fazla Kapatılmış</Table.Cell>
				<Table.Cell>{_.filter(repetitive_conversation, (it) => it.length >= 5).length || 0}</Table.Cell>
			</Table.Row>
			<Table.Row key={'all7'}>
				<Table.Cell>4 Kere Kapatılmış</Table.Cell>
				<Table.Cell>{_.filter(repetitive_conversation, (it) => it.length === 4).length || 0}</Table.Cell>
			</Table.Row>
			<Table.Row key={'all8'}>
				<Table.Cell>3 Kere Kapatılmış</Table.Cell>
				<Table.Cell>{_.filter(repetitive_conversation, (it) => it.length === 3).length || 0}</Table.Cell>
			</Table.Row>
			<Table.Row key={'all9'}>
				<Table.Cell>2 Kere Kapatılmış</Table.Cell>
				<Table.Cell>{_.filter(repetitive_conversation, (it) => it.length === 2).length || 0}</Table.Cell>
			</Table.Row>
			{/* {_.map(_.orderBy(data, [column], [direction]), (val, index) => (
				<Table.Row key={index}>
					<Table.Cell>{val.cid}</Table.Cell>
					<Table.Cell>{(val && val.count) || 0}</Table.Cell>
					<Table.Cell>
						<Button
							icon
							primary
							onClick={() => {
								const win = window.open('/#' + val.cid, '_blank');
								win.focus();
							}}
						>
							<Icon name="chat"></Icon>
						</Button>
					</Table.Cell>
				</Table.Row>
			))} */}
		</Table.Body>
	);
	async componentDidMount() {
		let typeQuery = [];
		let pairs = {};
		let group = [];
		let select = [];
		let filter = [];
		let { start_date, end_date, pid, agent_role, agent_id, selecteGroup, selectedPlatform } = this.state;
		let valueArr = this.state.value.length ? this.state.value : TypeList;
		let { product } = this.props;
		_.each(valueArr, (it) => {
			typeQuery = _.concat(typeQuery, it.type);
			if (it.group) {
				if (group.length) group = _.intersection(group, it.group);
				else group = it.group;
			}
			if (it.select) {
				if (select.length) select = _.intersection(select, it.select);
				else select = it.select;
			}
			if (it.pairs) pairs = _.assignIn(it.pairs);
		});

		start_date = moment(start_date).format();
		end_date = moment(end_date).format();
		typeQuery = _.uniq(typeQuery);
		if (agent_role === 'agent') {
			filter = { type: typeQuery, pid: this.state.pid, agent: agent_id };
			this.setState({ selectedAgent: agent_id });
		} else {
			filter = { type: typeQuery, pid: this.state.pid };
		}
		if (selectedPlatform !== 'all') _.set(filter, 'platform', selectedPlatform);
		else _.unset(filter, 'platform');
		pairs.platform = 'platform';
		if (group.length) group = _.union(group, ['type']);
		if (select.length) select = _.union(select, ['type', 'day']);
		await fetch('/api/dahi/message/getLiveChat', {})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				this.setState({
					productAgentList:
						data.result &&
						data.result.agents &&
						_.filter(data.result.agents, function (it) {
							return it.type !== 'viewer';
						}),
					productOldAgentList: data.result && data.result.old_agents,
					closeTags: data.result && data.result.staticOptions && data.result.staticOptions.closeTags,
					botId: data.result && data.result.bot.bid,
					bot_id: data.result && data.result.bot.id,
					chat_groups: data.result && data.result.staticOptions && data.result.staticOptions.groups,
					chat_teams: data.result && data.result.staticOptions && data.result.staticOptions.teams,
				});
			});
		let livechat_agent = _.find(this.state.productAgentList, (it) => it.id === this.props.access.user.loggedUserObj.extra.user_id);
		if (livechat_agent && livechat_agent.team && !livechat_agent.team_admin) {
			let showingproductAgentList2;
			if (product && product.live && product.live.settings && product.live.settings.analyticView && product.live.settings.analyticView.agentTeams) {
				showingproductAgentList2 = _.filter(this.state.productAgentList, (it) => it.team === livechat_agent.team);
				let group_agents = _.map(showingproductAgentList2, (it) => it.id);
				filter = { type: typeQuery, pid: this.state.pid, agent: group_agents };
				pairs.select1 = 'select1';
			}
		}
		fetch('https://log.yapaytech.com/live/test/getInfo', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				include_hour: true,
				filter,
				select,
				group: ['type', 'id', 'topic', 'cid', 'agent'],
				pairs: { agent: 'select1', cid: 'select4', select1: 'select1', topic: 'select2', rate: 'select5', platform: 'platform', id: 'id' },
				options: {
					sum: 0,
				},
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let agentList = _.map(data.result, function (it) {
					return { key: it.agent, text: it.agent, value: it.agent, id: it.agent };
				});
				this.setState({ head: typeQuery });
				agentList = _.uniqBy(agentList, 'key');
				let filtered_data = _.orderBy(
					_.filter(data.result, (it) => it.count > 1),
					(o) => o.count,
					'desc'
				);
				let unique_total_closed = [];
				let agent_closed = _.filter(data.result, (it) => it.topic !== 'auto_close');
				let total_closed = _.sumBy(data.result, (it) => it.count);
				let repetitive_conversation = [];
				let unique_agent_closed = [];
				let one_close_agent_closed = [];
				_.map(
					_.groupBy(data.result, (it) => it.cid),
					(o) => {
						unique_total_closed.push(o);
					}
				);
				_.map(
					_.groupBy(agent_closed, (it) => it.cid),
					(o) => {
						if (o.length > 1) repetitive_conversation.push(o);
						unique_agent_closed.push(o);
						if (o.length === 1) one_close_agent_closed.push(o);
					}
				);
				this.setState({
					agent_closed,
					filtered_data,
					unique_total_closed,
					total_closed,
					repetitive_conversation,
					agentList: agentList,
					unique_agent_closed,
				});
			});
		fetch('/api/live/agent/list')
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				this.setState({ newList: data.agents, loading: false });
			});
	}
	handleFilterChange = (e, { text, value }) => this.setState({ selectedAgent: value, selectedAgentName: text });
	handleTopicChange = (e, { text, value }) => this.setState({ selectedTopic: value, selectedTopicName: text });
	handleGroupChange = (e, { text, value }) => this.setState({ groupBy: value });
	handleChange = (e, { name, value }) => this.setState({ [name]: value });
	handleFilterCheck(value) {
		let array = this.state.value || [];
		let exists = _.find(array, value);
		let valueArr = exists ? _.filter(array, (it) => it !== value) : _.concat([], array, value);
		this.setState({ value: valueArr });
	}
	filterSelectType = () => {
		this.setState({ filterType: !this.state.filterType });
	};
	toggle = () => this.setState((prevState) => ({ selectedDate: prevState.selectedDate === 'daily' ? 'hourly' : 'daily' }));
	componentDidUpdate(oldProps, oldState) {
		const check_list = [
			/* 'start_date',
			'end_date', */
			'selectedAgent',
			'value',
			'selectedDate',
			'groupBy',
			'selectedTopic',
			'selectedPlatform',
			'selectedWatsonsGroup',
			'selectedTeam',
			'newDataToggle',
		];
		for (let i = 0; i < check_list.length; i++) {
			const key = check_list[i];
			let timer;
			if (/* key === 'start_date' || key === 'end_date' */ key === 'newDataToggle') {
				if (this.props[key] !== oldProps[key]) {
					window.clearTimeout(timer);
					timer = setTimeout(() => this.getData(), 1000);
					break;
				}
			}
			if (!_.isArray(this.state[key])) {
				if (this.state[key] !== oldState[key]) {
					window.clearTimeout(timer);
					timer = setTimeout(() => this.getData(), 3000);
					break;
				}
			} else if (!_.isEqual(this.state[key], oldState[key])) {
				window.clearTimeout(timer);
				timer = setTimeout(() => this.getData(), 3000);
				break;
			}
		}
	}
	async getData() {
		this.setState({ loading: true });
		let typeQuery = [];
		let group = [];
		let selecteGroup = this.state.groupBy;
		let dayGroup = ['type', 'day', selecteGroup];
		let hourGroup = ['type', 'day', selecteGroup, 'hour'];
		let select = [];
		let { selectedDate, selectedTopic, selectedAgent, pid, selectedPlatform, selectedWatsonsGroup, productAgentList, selectedTeam } = this.state;
		let { start_date, end_date, product } = this.props;
		let showingproductAgentList2;
		if (selectedWatsonsGroup !== 'all') {
			showingproductAgentList2 = _.filter(productAgentList, (it) => it.group === selectedWatsonsGroup);
		} else {
			showingproductAgentList2 = productAgentList;
		}
		if (product && product.live && product.live.settings && product.live.settings.analyticView && product.live.settings.analyticView.agentTeams) {
			if (selectedTeam !== 'all') {
				showingproductAgentList2 = _.filter(productAgentList, (it) => it.team === selectedTeam);
			} else {
				showingproductAgentList2 = productAgentList;
			}
		}
		let livechat_agent = _.find(this.state.productAgentList, (it) => it.id === this.props.access.user.loggedUserObj.extra.user_id);
		if (livechat_agent && livechat_agent.team && !livechat_agent.team_admin) {
			let showingproductAgentList2;
			if (product && product.live && product.live.settings && product.live.settings.analyticView && product.live.settings.analyticView.agentTeams) {
				showingproductAgentList2 = _.filter(this.state.productAgentList, (it) => it.team === livechat_agent.team);
				let group_agents = _.map(showingproductAgentList2, (it) => it.id);
				filter = { type: typeQuery, pid: this.state.pid, agent: group_agents };
			}
		}
		let group_agents = _.map(showingproductAgentList2, (it) => it.id);
		_.each(this.state.value, (it) => {
			typeQuery = _.concat(typeQuery, it.type);
			if (it.group) {
				if (group.length) group = _.intersection(group, it.group);
				else group = it.group;
			}
			if (it.select) {
				if (select.length) select = _.intersection(select, it.select);
				else select = it.select;
			}
		});

		start_date = moment(start_date).format();
		end_date = moment(end_date).format();
		typeQuery = _.uniq(typeQuery);
		if (group.length) group = _.union(group, ['type']);
		if (select.length) select = _.union(select, ['type', 'day']);
		let filter = { type: typeQuery, pid: this.state.pid };
		if (selectedAgent !== 'all') {
			filter.agent = selectedAgent;
		} else {
			if (selectedWatsonsGroup !== 'all') {
				filter.agent = group_agents;
			} else {
				delete filter.agent;
			}
			if (product && product.live && product.live.settings && product.live.settings.analyticView && product.live.settings.analyticView.agentTeams) {
				if (selectedTeam !== 'all') {
					filter.agent = group_agents;
				} else {
					delete filter.agent;
				}
			}
		}
		if (selectedTopic !== 'all') {
			filter.topic = selectedTopic;
		} else {
			delete filter.topic;
		}
		if (!(selectedDate === 'daily')) {
			//filter.day = selectedDate;
			dayGroup = ['type', selecteGroup, 'hour'];
		}
		if (selectedPlatform !== 'all') _.set(filter, 'platform', selectedPlatform);
		else _.unset(filter, 'platform');
		fetch('https://log.yapaytech.com/live/test/getInfo', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				include_hour: true,
				filter,
				select,
				group: ['type', 'id', 'topic', 'cid', 'agent'],
				pairs: { agent: 'select1', cid: 'select4', select1: 'select1', topic: 'select2', rate: 'select5', platform: 'platform', id: 'id' },
				options: {
					sum: 0,
				},
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let agentList = _.map(data.result, function (it) {
					return { key: it.agent, text: it.agent, value: it.agent, id: it.agent };
				});
				this.setState({ head: typeQuery });
				agentList = _.uniqBy(agentList, 'key');
				let filtered_data = _.orderBy(
					_.filter(data.result, (it) => it.count > 1),
					(o) => o.count,
					'desc'
				);
				let unique_total_closed = [];
				let agent_closed = _.filter(data.result, (it) => it.topic !== 'auto_close');
				let total_closed = _.sumBy(data.result, (it) => it.count);
				let repetitive_conversation = [];
				let unique_agent_closed = [];
				let one_close_agent_closed = [];
				_.map(
					_.groupBy(data.result, (it) => it.cid),
					(o) => {
						unique_total_closed.push(o);
					}
				);
				_.map(
					_.groupBy(agent_closed, (it) => it.cid),
					(o) => {
						if (o.length > 1) repetitive_conversation.push(o);
						unique_agent_closed.push(o);
						if (o.length === 1) one_close_agent_closed.push(o);
					}
				);
				this.setState({
					agent_closed,
					filtered_data,
					unique_total_closed,
					total_closed,
					repetitive_conversation,
					agentList: agentList,
					unique_agent_closed,
					loading: false,
				});
			});
	}
	formatTime(value) {
		const totalSeconds = Math.floor(value / 1000); // Milisaniyeyi saniyeye çevirme
		const hours = Math.floor(totalSeconds / 3600); // Saat hesaplama
		const remainingSeconds = totalSeconds % 3600; // Saat hesabından kalan saniyeler
		const minutes = Math.floor(remainingSeconds / 60); // Dakika hesaplama
		const seconds = remainingSeconds % 60; // Dakika hesabından kalan saniyeler

		return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
	}
	async exportExcel(productAgentList, closeTags, t) {
		this.setState({ allClosedloading: true });
		let { start_date, end_date } = this.props;
		let { pid } = this.state;
		let closedData = await fetch('https://log.yapaytech.com/live/test/getInfo?closed', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				include_hour: true,
				filter: {
					type: ['closed', 'agentChatTime'],
					pid: pid,
				},
				select: '',
				group: ['type', 'agent', 'rate', 'cid', 'date', 'platform', 'topic', 'comment'],
				pairs: {
					agent: 'select1',
					topic: 'select2',
					cid: 'select4',
					rate: 'select5',
					platform: 'platform',
					comment: 'select7',
				},
				options: {
					sum: 1,
					avg: 1,
				},
			}),
		})
			.then((response) => response.json())
			.then((response) => {
				return response.result; //_.filter(response.result, (it) => it.agent !== pid);
			});
		let only_time = _.filter(closedData, { type: 'agentChatTime' });
		let allClosedData = _.map(
			_.filter(closedData, (a) => a.topic !== 'auto_close'),
			(o) => {
				let agent = _.find(productAgentList, { id: o.agent });
				let topic = _.find(closeTags, { id: o.topic });
				let agentTime = _.find(only_time, { cid: o.cid, agent: o.agent });
				let sumTime = agentTime && agentTime.sum;
				return {
					agent: (agent && agent.developer) || o.agent,
					name: (agent && agent.name) || '',
					count: o.count,
					date: moment(o.date).format('DD-MM-YYYY'),
					len: o.len,
					platform: pid === '8246c490-2e1c-11eb-ad5c-b51ab8880cfc' && o.platform === 'web' ? 'flo' : o.platform,
					rate: o.rate,
					topic: (topic && topic.title) || o.topic,
					cid: o.cid,
					agentTime: (sumTime && this.formatTime(sumTime)) || '-',
					agentTimeMin: sumTime ? parseFloat((sumTime / 1000 / 60).toFixed(2)) : '-',
				};
			}
		);
		let sheets = [];
		sheets.push({
			name: 'all_closed_list',
			x: [
				{ title: t('email'), key: 'agent' },
				{ title: t('name'), key: 'name' },
				{ title: t('topic'), key: 'topic' },
				{ title: t('date'), key: 'date' },
				{ title: t('platform'), key: 'platform' },
				{ title: t('conversation'), key: 'cid' },
				{ title: t('rate'), key: 'rate' },
				{ title: t('agentChatTime'), key: 'agentTime' },
				{ title: t('agentChatTime'), key: 'agentTimeMin' },
			],
			datasets: allClosedData,
		});
		let now = moment();
		fetch('https://log.yapaytech.com/analytic/download', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				filename:
					moment(start_date).format('DD-MM-YYYY_HH:mm') +
					'_' +
					moment(end_date).format('DD-MM-YYYY_HH:mm') +
					'_all_closed_analytic_' +
					pid +
					'_' +
					'all' +
					'_' +
					now.valueOf(),
				sheets,
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let dataurl = data.url;

				var a = document.createElement('a');
				a.href = dataurl;
				a.setAttribute('download', dataurl);
				a.click();
				this.setState({ allClosedloading: false });
			});
	}
	dateChange = ({ selection }) => {
		let start_date = moment(selection.startDate).startOf('day');
		let end_date = moment(selection.endDate);
		if (end_date.format('YYYY-MM-DD') !== this.state.today.format('YYYY-MM-DD')) {
			end_date = end_date.endOf('day');
		} else {
			end_date = moment();
		}
		this.setState({ start_date, end_date });
	};
	showingBar(data, barStyle) {
		switch (barStyle) {
			case 'line':
				return <Line data={data} options={barOptions} />;
			case 'bar':
				return <Bar data={data} options={barOptions} />;
			case 'stackbar':
				return <Bar data={data} options={barOptionsStack} />;
			case 'radar':
				return <Radar data={data} />;
			default:
				return <Line data={data} options={barOptions} />;
		}
	}
	render() {
		const {
			selectedAgent,
			selectedTopic,
			selectedBarStyle,
			pid,
			gettingDataDateHour,
			loadingGraph,
			selectedPlatform,
			productOldAgentList,
			selectedWatsonsGroup,
			selectedTeam,
			chat_groups,
			chat_teams,
			filtered_data,
			total_closed,
			unique_total_closed,
			agent_closed,
			repetitive_conversation,
			unique_agent_closed,
		} = this.state;
		let { start_date, end_date, t, i18n, product, platformList } = this.props;
		let { agent_role } = this.state;
		let ratePoint;
		if (this.props.product.live.settings.analyticView) {
			ratePoint = this.props.product.live.settings.analyticView.ratePoint;
		}
		let watsons_groups = [
			{
				text: t('allGroups'),
				value: 'all',
				id: 'all',
				key: 'all',
			},
		];
		if (chat_groups && chat_groups.length) {
			_.each(chat_groups, (it) =>
				watsons_groups.push({
					text: it.label,
					value: it.id,
					id: it.id,
					key: it.id,
				})
			);
		}
		let teams = [
			{
				text: t('allTeams'),
				value: 'all',
				id: 'all',
				key: 'all',
			},
		];
		if (chat_teams && chat_teams.length) {
			_.each(chat_teams, (it) =>
				teams.push({
					text: it.label,
					value: it.id,
					id: it.id,
					key: it.id,
				})
			);
		}
		let isMock = product.live && product.live.settings.mock_analytic;
		let gettingData = isMock ? MockAgents.closedByTopic : this.state.gettingData;
		let newList = this.state.newList;
		let ng = _.map(gettingData, function (it) {
			return {
				count: it.count,
				type: it.type,
				agent: it.agent,
				topic: it.topic,
				rate: parseInt(it.rate) || 0,
				total: it.count * (parseInt(it.rate) || 0),
			};
		});
		let fd = _.map(this.state.filteredData, function (it) {
			return {
				count: it.count,
				type: it.type,
				agent: it.agent,
				rate: parseInt(it.rate) || 0,
				total: it.count * (parseInt(it.rate) || 0),
			};
		});
		let dataloading = this.state.dataloading;
		let gGettingData = _.groupBy(ng, this.state.groupBy);
		let agentList = this.state.agentList;
		let productAgentList2 = this.state.productAgentList;
		let closeTags = this.state.closeTags;
		let head = this.state.head;
		let productAgentList = this.state.productAgentList;
		let ownerName =
			this.props && this.props.access && this.props.access.user && this.props.access.user.loggedUserObj && this.props.access.user.loggedUserObj.name;
		_.map(productAgentList2, function (it) {
			return _.map(head, function (d) {
				return _.assign(it, { count: 0, ratedCount: 0, avgRate: 0, rates: { one: 0, two: 0, three: 0, four: 0, five: 0 } });
			});
		});
		let newData = [];
		let sumFilterData = {
			count: _.sumBy(fd, 'count'),
			ratedCount: _.sumBy(
				_.filter(fd, function (it) {
					return it.rate > 0;
				}),
				'count'
			),
			total: _.sumBy(fd, 'total'),
			rates: {
				one: _.sumBy(
					_.filter(fd, (o) => o.rate === 1),
					'count'
				),
				two: _.sumBy(
					_.filter(fd, (o) => o.rate === 2),
					'count'
				),
				three: _.sumBy(
					_.filter(fd, (o) => o.rate === 3),
					'count'
				),
				four: _.sumBy(
					_.filter(fd, (o) => o.rate === 4),
					'count'
				),
				five: _.sumBy(
					_.filter(fd, (o) => o.rate === 5),
					'count'
				),
			},
		};

		newData = _.map(gGettingData, function (it, i) {
			return {
				count: _.sumBy(it, 'count'),
				type: it[0].type,
				agent: it[0].agent,
				topic: (_.find(closeTags, { id: it[0].topic }) && _.find(closeTags, { id: it[0].topic }).title) || it[0].topic,
				ratedCount: _.sumBy(
					_.filter(it, function (o) {
						return o.rate > 0;
					}),
					'count'
				),
				total: _.sumBy(it, 'total'),
				avgRate:
					_.sumBy(it, 'total') /
						_.sumBy(
							_.filter(it, function (o) {
								return o.rate > 0;
							}),
							'count'
						) || 0,
				rates: {
					one: _.find(it, (o) => o.rate === 1) && _.find(it, (o) => o.rate === 1).count,
					two: _.find(it, (o) => o.rate === 2) && _.find(it, (o) => o.rate === 2).count,
					three: _.find(it, (o) => o.rate === 3) && _.find(it, (o) => o.rate === 3).count,
					four: _.find(it, (o) => o.rate === 4) && _.find(it, (o) => o.rate === 4).count,
					five: _.find(it, (o) => o.rate === 5) && _.find(it, (o) => o.rate === 5).count,
				},
			};
		});
		if (this.state.groupBy === 'agent') {
			_.map(newData, function (it) {
				var e = _.findIndex(agentList, function (o) {
					return o.key === it.agent;
				});
				return _.assign(agentList[e], { count: it.count, ratedCount: it.ratedCount, avgRate: it.avgRate, total: it.total, rates: it.rates });
			});
		}
		let gettingDataDate = isMock ? MockAgents.closedByDate : this.state.gettingDataDate;
		_.map(productAgentList, function (it, i) {
			let name = _.find(newList, { email: it.developer }) && _.find(newList, { email: it.developer }).name;
			if (i === 0) {
				return (it.name = ownerName || it.developer);
			}
			return (it.name = name ? name : it.developer);
		});

		productAgentList = _.filter(productAgentList, function (it) {
			return it.id !== '5e6f519560b2b4d07559fcf8';
		});

		let dropCloseList = _.map(closeTags, function (it) {
			return { text: it.title, key: it.id, value: it.id };
		});
		var groupBy = [
			{
				text: t('topic'),
				key: 'topic',
				value: 'topic',
			},
			{
				text: t('agent'),
				key: 'agent',
				value: 'agent',
			},
		];
		let othersdata = {
			count: 0,
			id: 'others',
			key: 'others',
			taken: 0,
			text: 'others',
			value: 'others',
		};
		let showingproductAgentList2;
		if (selectedWatsonsGroup !== 'all') {
			showingproductAgentList2 = _.filter(productAgentList2, (it) => it.group === selectedWatsonsGroup);
		} else {
			showingproductAgentList2 = productAgentList2;
		}
		let livechat_agent = _.find(this.state.productAgentList, (it) => it.id === this.props.access.user.loggedUserObj.extra.user_id);
		if (product && product.live && product.live.settings && product.live.settings.analyticView && product.live.settings.analyticView.agentTeams) {
			if (selectedTeam !== 'all') {
				showingproductAgentList2 = _.filter(productAgentList2, (it) => it.team === selectedTeam);
			} else {
				showingproductAgentList2 = productAgentList2;
			}
			if (livechat_agent && livechat_agent.team && !livechat_agent.team_admin) {
				if (product && product.live && product.live.settings && product.live.settings.analyticView && product.live.settings.analyticView.agentTeams) {
					showingproductAgentList2 = _.filter(this.state.productAgentList, (it) => it.team === livechat_agent.team);
				}
			} else {
				if (selectedTeam !== 'all') {
					showingproductAgentList2 = _.filter(productAgentList2, (it) => it.team === selectedTeam);
				} else {
					showingproductAgentList2 = productAgentList2;
				}
			}
		}
		let dropAgentList = _.map(showingproductAgentList2, function (it) {
			return { text: it.developer, key: it.id, value: it.id };
		});
		dropAgentList = _.concat({ text: t('allAgent'), key: 'all', value: 'all' }, dropAgentList);
		dropCloseList = _.concat({ text: t('allTopic'), key: 'all', value: 'all' }, dropCloseList);

		if (this.state.loading)
			return (
				<Container>
					<Segment style={{ marginBottom: '20px' }}>
						<Page.Loader></Page.Loader>
					</Segment>
				</Container>
			);
		_.map(agentList, function (it) {
			let n = _.findIndex(productAgentList2, { id: it.key });
			if (n >= 0) {
				dataloading = false;
				return _.assign(productAgentList2[n], it);
			} else if (/bot/.test(it.key) || it.key === pid) {
				console.log('bot');
			} else {
				if (/yapaytech/.test(it.key)) {
					if (productOldAgentList && productOldAgentList.length) {
						let oldAgent = _.find(productOldAgentList, { id: it.key });

						if (oldAgent) {
							var e = _.findIndex(productAgentList2, function (o) {
								return o.key === it.key;
							});
							if (e >= 0) return _.assign(productAgentList2[e], it);
							else
								productAgentList2.push({
									developer: 'Eski-' + oldAgent.developer,
									id: oldAgent.id,
									wid: oldAgent.id,
									type: 'standard',
									fullname: oldAgent.fullname,
									count: it.count,
									ratedCount: it.ratedCount,
									avgRate: it.avgRate,
									rates: it.rates,
									name: it.fullname,
								});
						} else {
							othersdata = _.assign({
								count: othersdata.count + (it.count || 0),
							});
						}
					} else {
						othersdata = _.assign({
							count: othersdata.count + (it.count || 0),
						});
					}
				}
			}
		});
		othersdata = {
			count: othersdata.count,
			id: 'others',
			key: 'others',
			text: 'others',
			value: 'others',
			developer: t('oldAgents'),
		};
		productAgentList2 = _.filter(productAgentList2, function (it) {
			return it && it.id && it.id !== '5e6f519560b2b4d07559fcf8';
		});
		let tcloumn = this.state.groupBy === 'topic' ? 'count' : 'closed';
		if (agentList) {
			dataloading = false;
		}
		if (this.state.loading || dataloading)
			return (
				<Container>
					<Segment style={{ marginBottom: '20px' }}>
						<Page.Loader></Page.Loader>
					</Segment>
				</Container>
			);
		_.map(productAgentList2, function (it, i) {
			let name = _.find(newList, { email: it.developer }) && _.find(newList, { email: it.developer }).name;

			if (i === 0) {
				return (it.name = ownerName || it.developer);
			}
			return (it.name = name ? name : it.developer);
		});

		let allConversationTable =
			product && product.live && product.live.settings && product.live.settings.analyticView && product.live.settings.analyticView.allConversationTable;
		return (
			<Container>
				<Segment style={{ marginBottom: '20px' }}>
					<Segment attached="bottom">
						<div style={{ display: 'flex' }}>
							{/* <Dropdown
								selection
								options={platformList}
								value={selectedPlatform}
								floating
								labeled
								button
								icon="filter"
								className="icon"
								name="selectedPlatform"
								onChange={(e, { name, value }) => this.setState({ selectedPlatform: value })}
							/> */}
							{/* {product &&
							product.live &&
							product.live.settings &&
							product.live.settings.analyticView &&
							product.live.settings.analyticView.watsonsgroups ? (
								<Dropdown
									selection
									options={watsons_groups}
									value={selectedWatsonsGroup}
									floating
									labeled
									button
									icon="filter"
									className="icon"
									name="selectedWatsonsGroup"
									onChange={(e, { name, value }) => this.setState({ selectedWatsonsGroup: value })}
								/>
							) : (
								''
							)} */}
							{/* {product &&
							product.live &&
							product.live.settings &&
							product.live.settings.analyticView &&
							product.live.settings.analyticView.agentTeams &&
							((livechat_agent&&livechat_agent.team_admin) || (livechat_agent && livechat_agent.type && livechat_agent.type === 'admin')) ? (
								<Dropdown
									selection
									options={teams}
									value={selectedTeam}
									floating
									labeled
									button
									icon="filter"
									className="icon"
									name="selectedTeam"
									onChange={(e, { name, value }) => this.setState({ selectedTeam: value })}
								/>
							) : (
								''
							)} */}
							{/* {agent_role !== 'agent' ? (
								<Dropdown
									options={dropAgentList}
									selection
									defaultValue={this.state.selectedAgent || dropAgentList[0].value}
									icon="filter"
									floating
									labeled
									button
									className="icon"
									onChange={this.handleFilterChange}
								></Dropdown>
							) : (
								''
							)} */}

							{/* <Dropdown
								placeholder="Select Topic"
								options={dropCloseList}
								selection
								defaultValue={dropCloseList[0].value}
								icon="filter"
								floating
								labeled
								button
								className="icon"
								onChange={this.handleTopicChange}
							></Dropdown>
							<Dropdown
								placeholder="Group By"
								options={groupBy}
								selection
								defaultValue={groupBy[1].value}
								icon="circle outline"
								floating
								labeled
								button
								className="icon"
								onChange={this.handleGroupChange}
							></Dropdown> */}
						</div>
						{/* {allConversationTable ? (
							<div style={{ marginTop: '10px', display: 'flex' }}>
								<Button
									icon
									labelPosition="left"
									color="green"
									style={{ marginLeft: 'auto' }}
									loading={this.state.allClosedloading}
									onClick={() => this.exportExcel(productAgentList, closeTags, t, product)}
								>
									<Icon name="file excel outline" />
									{t('dowloadAllClosed')}
								</Button>
							</div>
						) : null} */}
					</Segment>
					<Table sortable fixed width={16} style={{ padding: '0px' }}>
						{this.TableHead(gGettingData, [], this.state.head, this.state.column, this.state.direction, tcloumn, ratePoint, t)}
						{this.TableLine(
							filtered_data,
							productAgentList,
							closeTags,
							this.state.groupBy,
							showingproductAgentList2,
							this.state.column,
							this.state.direction,
							ratePoint,
							selectedAgent,
							sumFilterData,
							t,
							selectedTopic,
							unique_total_closed,
							total_closed,
							repetitive_conversation,
							agent_closed,
							unique_agent_closed
						)}
					</Table>
				</Segment>
			</Container>
		);
	}
}
// date array
var getDateArray = function (start, end) {
	var arr = [],
		dt = new Date(moment(start).startOf('d'));
	while (dt <= new Date(moment(end).startOf('d'))) {
		arr.push(new Date(dt));
		dt.setDate(dt.getDate() + 1);
	}
	return arr;
};
var getHourArray = function () {
	var arr = [],
		dt = 0;

	while (dt < 24) {
		arr.push(dt);
		dt++;
	}
	return arr;
};
function chartData(data, start_date, end_date, selectedDate, closeTags, group, productAgentList, displayName, t, i18n) {
	moment.locale(i18n.language);
	let startDate = new Date(start_date);
	let endDate = new Date(end_date);
	let labels = [];
	var dateArr = getDateArray(startDate, endDate);
	var hourArr = getHourArray();
	let gdata = _.groupBy(data, group);
	if (selectedDate === 'daily') {
		_.map(gdata, function (it, index) {
			return _.each(dateArr, function (d, i) {
				if (_.findIndex(it, { dayNumber: moment(d).dayOfYear() }) === -1) {
					it.push({ type: it[0].type, topic: it[0].topic, agent: it[0].agent, day: moment(d).format(), dayNumber: moment(d).dayOfYear(), count: 0 });
				}
			});
		});
	} else {
		_.map(gdata, function (it, index) {
			return _.each(hourArr, function (d, i) {
				if (_.findIndex(it, { hour: d }) === -1) {
					it.push({ type: it[0].type, topic: it[0].topic, agent: it[0].agent, day: it[0].day, hour: d, dayNumber: it[0].dayNumber, count: 0 });
				}
			});
		});
	}
	if (selectedDate === 'daily') {
		labels = _.map(dateArr, (it) => moment(it).format('DD-MMM'));
	} else {
		labels = hourArr;
	}
	let i = 0;
	let datasets = _.map(gdata, function (it) {
		if (selectedDate === 'daily') {
			it = _.sortBy(it, ['day', 'asc']);
		} else {
			it = _.sortBy(it, ['hour', 'asc']);
		}
		let item = '';
		let title = '';
		if (group === 'topic') {
			item = _.find(closeTags, { id: it[0].topic });
			title = item && item.title;
		} else {
			item = _.find(productAgentList, { id: it[0].agent });
			title = item && item[displayName];
		}
		let color = colors2[i++ % colors2.length]; //randomMC.getColor({ shades: ['200', '700'], text: title || it[0][group] });
		return {
			label: title || it[0][group],
			day: _.map(it, (item) => moment(item.day, 'DD-MM').format()),
			data: _.map(it, (item) => item.count),
			borderColor: color,
			backgroundColor: color,
			fill: false,
		};
	});
	return {
		labels,
		datasets,
	};
}
function chartDataHourly(data, group, start_date, end_date, closeTags, t, productAgentList, displayName) {
	let startDate = new Date(start_date);
	let endDate = new Date(end_date);
	let labels = [];
	var dateArr = getDateArray(startDate, endDate);
	var hourArr = getHourArray();
	let gdata = _.groupBy(data, group);
	_.map(dateArr, (it) => {
		return _.map(hourArr, (o) => {
			labels.push(moment(it).format('DD/MM') + ' - ' + moment(o, 'H').format('HH'));
		});
	});
	let datasets = [];
	let i = 0;
	datasets = _.map(gdata, (o) => {
		let color = colors2[i++ % colors2.length];
		let hobj;
		let data_arr = [];
		let oitem = '';
		let title = '';
		if (group === 'topic') {
			oitem = _.find(closeTags, { id: o[0].topic });
			title = oitem && oitem.title;
		} else {
			oitem = _.find(productAgentList, { id: o[0].agent });
			title = oitem && oitem[displayName];
		}
		_.map(dateArr, (ditem) => {
			return _.map(hourArr, (it) => {
				/* if (it >= 2) {
					hobj = _.find(o, {
						dayNumber: moment(ditem).dayOfYear(),
						hour: it - 2,
					});
				} else if (it === 0) {
					hobj = _.find(o, {
						dayNumber: moment(ditem).dayOfYear() - 1,
						hour: it + 22,
					});
				} else {
					hobj = _.find(o, {
						dayNumber: moment(ditem).dayOfYear(),
						hour: it + 22,
					});
				} */
				hobj = _.find(o, {
					dayNumber: moment(ditem).dayOfYear(),
					hour: it,
				});
				return data_arr.push((hobj && hobj.count) || 0);
			});
		});
		return {
			label: title || o[0][group],
			data: data_arr,
			borderColor: color,
			backgroundColor: color,
			fill: false,
		};
	});
	return {
		labels,
		datasets,
	};
}
const stateToProps = (state) => ({ access: state.access, location: state.router.location, product: state.product });

export default connect(stateToProps)(withTranslation()(Analytic));
